import { OlVectorLayer } from "@daniellang/schulwegeplan/components/ol/layers/ol-vector-layer";

import type { Vector } from "ol/source";
import VectorSource from "ol/source/Vector";
import Style, { type StyleLike } from 'ol/style/Style';
import type { FlatStyleLike } from "ol/style/flat";
import Icon from "ol/style/Icon";
import GeoJSON from "ol/format/GeoJSON";
import type { FeatureLike } from "ol/Feature";

import { customElement } from "lit/decorators.js";
import type { DangerZoneFeature } from "./feature-types";
import { hasPanorama } from "./feature-types";

import dangerIconSvg from "../../assets/svg/danger.svg";

const geoJson = new GeoJSON({
    dataProjection: "EPSG:4326",
    featureProjection: "EPSG:3857",
});

@customElement("swp-dangerzones")
export class SwpDangerzonesLayer extends OlVectorLayer {

    protected isFeatureInteractive(feature: FeatureLike): boolean {
        return hasPanorama(feature);
    }

    protected createStyle(): StyleLike | FlatStyleLike | null | undefined {
        return (feature: FeatureLike) => {
            const color = feature.get("color") || "#ff0000";

            return new Style({
                image: new Icon({
                    src: dangerIconSvg,

                    color,
                    scale: 0.055,
                    anchor: [0.5, 0.5]
                }),
            });
        };
        
    }

    protected createSource(): Vector {
        const dangerZonesSource = new VectorSource();

        (async () => {
            const dangerZonesResponse = await fetch("./assets/geojson/dangerzones.geojson");
            const dangerZonesData = await dangerZonesResponse.json();
            const dangerZones = geoJson.readFeatures(dangerZonesData) as DangerZoneFeature[];

            dangerZonesSource.addFeatures(dangerZones);
        })();
        
        return dangerZonesSource;
    }

}
